"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AcPdfEditorCanvas_1 = require("./AcPdfEditorCanvas");
var AcPdfEditorSideMenu_1 = require("./AcPdfEditorSideMenu");
var __1 = require("../..");
exports.AcPdfEditor = function (_a) {
    var show = _a.show, originalWidth = _a.originalWidth, originalHeight = _a.originalHeight, rotatedWidth = _a.rotatedWidth, rotatedHeight = _a.rotatedHeight, pageNumber = _a.pageNumber, rotate = _a.rotate, sendEditedFax = _a.sendEditedFax, handleCancel = _a.handleCancel, fabricDataMapJSON = _a.fabricDataMapJSON, faxDocument = _a.faxDocument, onCreateDraft = _a.onCreateDraft, updateRotationArray = _a.updateRotationArray;
    return (react_1.default.createElement("div", { style: {
            position: 'absolute',
            display: show ? 'block' : 'none',
            top: 0,
            left: 0,
            backgroundColor: 'transparent',
        } },
        react_1.default.createElement("div", { className: "d-flex flex-row" },
            react_1.default.createElement("div", { style: {
                    position: 'relative',
                    width: rotatedWidth,
                    height: rotatedHeight,
                    backgroundColor: 'transparent',
                } },
                react_1.default.createElement(AcPdfEditorCanvas_1.AcPdfEditorCanvas, { fabricDataMapJSON: fabricDataMapJSON, pageNumber: pageNumber, originalWidth: originalWidth, originalHeight: originalHeight, rotatedWidth: rotatedWidth, rotatedHeight: rotatedHeight, rotate: rotate, updateRotationArray: updateRotationArray })),
            react_1.default.createElement(AcPdfEditorSideMenu_1.AcPdfEditorSideMenu, { faxDocument: faxDocument, sendEditedFax: sendEditedFax, handleCancel: handleCancel, onCreateDraft: onCreateDraft })),
        show && react_1.default.createElement(__1.AcSessionTimeOutNotificationDialog, null)));
};
exports.AcPdfEditor.displayName = 'AcPdfEditor';
//# sourceMappingURL=AcPdfEditor.js.map